import { connect } from 'react-redux'
import { approveIdeaById } from 'services/ideas'
import { hideDialog } from 'support/popup_dialogs/modal_alert_controller/ModalActions'
import ApproveView from './ApproveView'

const mapStateToProps = (state, ownProps) => ({
  id: ownProps.id,
  approvedReasons: ownProps.approvedReasons,
})

const mapDispatchToProps = dispatch => {
  return {
    onClick: (id, reason, returnInvestment) => {
      dispatch(approveIdeaById(id, reason, returnInvestment))
      dispatch(hideDialog())
      window.location.reload()
    },
    cancelButtonAction: () => dispatch(hideDialog()),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ApproveView)
